// Tiny shared helper used by admin/manager UI to trigger a password reset
// for any user (staff, recruiter, student). Surfaces a toast/alert and
// returns true on success.

const API = process.env.REACT_APP_BACKEND_URL;

export async function sendAdminResetLink({ user_id, email, displayName }) {
  if (!user_id && !email) {
    alert('Cannot send reset link — missing user identifier.');
    return false;
  }
  const who = displayName || email || 'this user';
  if (!window.confirm(`Send a password-reset email to ${who}?\n\nThe user will receive a secure link that expires in 60 minutes.`)) {
    return false;
  }
  try {
    const res = await fetch(`${API}/api/auth/admin/send-reset-link`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ user_id, email }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
      alert(`Could not send reset link: ${data.detail || res.status}`);
      return false;
    }
    alert(
      data.email_sent
        ? `Reset link emailed to ${data.email}.\nLink expires in ${data.expires_in_minutes} min.`
        : `Reset link generated for ${data.email}, but the email did NOT go out.\nPlease check Resend configuration or ask the user to use Forgot Password from the login screen.`,
    );
    return true;
  } catch (err) {
    alert(`Could not send reset link: ${err.message}`);
    return false;
  }
}
